import React, { useState, useEffect } from 'react';
import { Button, Popover } from '@barges/react';
import { analyticsService } from '@common/analytics';
import { useDispatch } from 'react-redux';
import { useLogout } from './use_logout';
import classes from '../classes.module.scss';
import { SvgIcon } from '../../../../common/sprites';
import { loadHomePage } from '../../../actions/home_page';
import { getAnonymousUser, logOutClear, setDynamicConfig } from '../../../actions/application';

import '@barges/scss/lib/title.css';
import '@barges/scss/lib/button.css';

export const MODAL = 'modal';
export const SETTINGS = 'settings';

const SignOut = ({ t, theme = SETTINGS }) => {
  const dispatch = useDispatch();

  const callbacks = {
    onHomePageLoad: () => dispatch(loadHomePage(true)),
    onAnonymousUserSet: () => dispatch(getAnonymousUser()),
    onLogoutClear: () => dispatch(logOutClear()),
    onDynamicConfigSet: (clientSettings) => dispatch(setDynamicConfig(clientSettings, true))
  };
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const {
    loading,
    success,
    logout,
    reset
  } = useLogout(callbacks);

  useEffect(() => {
    if (success) {
      reset();
    }
  }, [success, reset]);

  const signOutClick = () => {
    setShowSignOutModal(true);
    analyticsService.trackPageVisit('sign out? popup');
  };

  const signOutCancel = () => {
    setShowSignOutModal(false);
  };

  const signOutOk = () => {
    setShowSignOutModal(false);
    logout();
  };

  const renderSingOutContent = () => (
    <div className={ classes.signOutContentContainer }>
      <div className={ classes.signOutHeader }>
        <b>{ t('app_name_title') }</b>
      </div>
      <div className={ classes.signOutBody }>
        { t('settings.are_you_sure_you_want_sign_out') }
      </div>
      <div className={ classes.footer }>
        <div className={ classes.signOutYesBtnContainer }>
          <button type="button" onClick={ signOutCancel } className={ classes.signOutCancelButton }>
            { t('settings.cancel') }
          </button>
        </div>
        <div className={ classes.signOutCancelBtnContainer }>
          <button type="button" onClick={ signOutOk } className={ classes.signOutYesButton }>
            { t('settings.yes') }
          </button>
        </div>
      </div>
    </div>
  );

  const renderSignOutButton = () => {
    const isModal = theme === MODAL;
    if (isModal) {
      return (
        <button
          type="button"
          className={ classes.signOutButtonModal }
          onClick={ signOutClick }
          disabled={ loading }
        >
          <SvgIcon
            id="popover_logout"
            size={ 24 }
          />
          <div className={ isModal ? classes.modalSignOutText : '' }>
            { t('settings.sign_out') }
          </div>
        </button>
      );
    }
    const icon = (
      <SvgIcon
        size={ 24 }
        id="sign_out"
        className={ classes.signOutImage }
      />
    );
    return (
      <div className={ classes.signOutButton }>
        <Button
          type="secondary"
          title={ t('settings.sign_out') }
          onClick={ signOutClick }
          icon={ icon }
          disabled={ loading }
        />
      </div>
    );
  };

  const isModal = theme === MODAL;
  return (
    <div className={ isModal ? classes.signOutContainerModal : classes.signOutContainer }>
      { renderSignOutButton() }
      <Popover
        isOpen={ showSignOutModal }
        onCloseButtonClick={ signOutCancel }
        centered
        className="sign-out-modal"
        closeOnBackdropClick
      >
        { renderSingOutContent()}
      </Popover>
    </div>
  );
};

export default SignOut;
